// extracted by mini-css-extract-plugin
export default {"onboardingPage":"uZy87J8vqEJHGyi3rnEc"};